import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {CargoSubtype, toCargoSubtype} from "./cargo-subtype";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";

export const ContainerVolumeInventoryValidator = t.intersection([
    t.type({}),
    t.partial({
        regionId: t.string,
        containerId: t.string,
        dttm: t.number,
        volume: t.number,
        volumeUnitOfMeasure: t.string,
        cargoSubtype: t.string,
        containerName: t.string,
        siteId: t.string,
        siteName: t.string,
        siteCompanyId: t.string,
        siteCompanyName: t.string,
        siteCompanyType: t.string,
        routeIds: t.array(t.string),
        routeNames: t.array(t.string),
        operatingAreaId: t.string,
        operatingAreaName: t.string,
        regionGeographicName: t.string,
    }),
]);

export const ContainerVolumeInventoryArrayValidator = t.array(ContainerVolumeInventoryValidator);

export type ContainerVolumeInventory = t.TypeOf<typeof ContainerVolumeInventoryValidator>;
export type ContainerVolumeInventoryArray = t.TypeOf<typeof ContainerVolumeInventoryArrayValidator>;

@Exclude()
export class ContainerVolumeInventoryEntity {
    @Expose()
    dttm?: number

    @Expose()
    volume?: number

    @Expose()
    volumeUnitOfMeasure?: string

    @Expose()
    @Transform(getDatabaseCodeTransformer(toCargoSubtype))
    cargoSubtype?: CargoSubtype

    @Expose()
    containerId?: string;

    @Expose()
    containerName?: string;

    @Expose()
    siteId?: string;

    @Expose()
    siteName?: string;

    @Expose()
    siteCompanyId?: string;

    @Expose()
    siteCompanyName?: string;

    @Expose()
    siteCompanyType?: string;

    @Expose()
    routeIds?: string[]

    @Expose()
    routeNames?: string[]

    @Expose()
    operatingAreaId?: string;

    @Expose()
    operatingAreaName?: string;

    @Expose()
    regionId?: string;

    @Expose()
    regionGeographicName?: string;

    /**
     * Constructor for ContainerVolumeInventoryEntity.
     * @hideconstructor
     */
    constructor() {
        // Empty constructor for 'class-transformer'
    }

    static from(containerVolumeInventory: ContainerVolumeInventory): ContainerVolumeInventoryEntity {
        return plainToInstance(
            ContainerVolumeInventoryEntity,
            containerVolumeInventory,
            {
                excludeExtraneousValues: true,
            }
        );
    }

    loadTypeValue(): Promise<ContainerVolumeInventory> {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSON(ContainerVolumeInventoryValidator, object);
    }

    asTypeValue(): ContainerVolumeInventory {
        const object = instanceToPlain(this, {
            excludeExtraneousValues: true,
        });
        return validateJSONNow(ContainerVolumeInventoryValidator, object);
    }
}
